import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { Globe } from 'lucide-react';
import { JURISDICTIONS } from '../../../../constants/compliance';

export function ByJurisdictionWidget({ dsrs = [] }) {
  const countByJurisdiction = {};
  JURISDICTIONS.forEach(j => { countByJurisdiction[j.value] = 0; });

  dsrs.forEach(dsr => {
    const jurisdiction = dsr.jurisdiction || 'JM';
    if (countByJurisdiction.hasOwnProperty(jurisdiction)) {
      countByJurisdiction[jurisdiction]++;
    }
  });

  const chartData = JURISDICTIONS.map(j => ({
    name: `${j.label} ${j.flag}`,
    count: countByJurisdiction[j.value],
    key: j.value,
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-slate-900 dark:bg-slate-100 text-white dark:text-slate-900 px-3 py-2 rounded text-sm border border-primary shadow-lg">
          <p className="font-semibold">{payload[0].payload.name}</p>
          <p>{payload[0].value} {payload[0].value === 1 ? 'request' : 'requests'}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Globe className="h-5 w-5 text-primary" />
          By Jurisdiction
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="w-full h-80">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData} margin={{ top: 5, right: 30, left: 0, bottom: 60 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="currentColor" vertical={false} opacity={0.2} />
              <XAxis
                dataKey="name"
                stroke="currentColor"
                style={{ fontSize: '12px' }}
                angle={-45}
                textAnchor="end"
                height={80}
                opacity={0.7}
              />
              <YAxis stroke="currentColor" style={{ fontSize: '12px' }} opacity={0.7} allowDecimals={false} />
              <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(26, 127, 100, 0.1)' }} />
              <Bar dataKey="count" fill="#1a7f64" radius={[4, 4, 0, 0]} isAnimationActive={true}>
                {chartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.count > 0 ? '#1a7f64' : 'rgba(226, 232, 240, 0.5)'}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}

export default ByJurisdictionWidget;
